// extracted by mini-css-extract-plugin
module.exports = {"Footer":"footer-module--Footer--1VU2P","Contact":"footer-module--Contact--3mK3w","Icon":"footer-module--Icon--1igGX","Info":"footer-module--Info--3AynC"};